import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import WebinarSessionVideoInterface from 'common/types/entities/WebinarSessionVideoInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createWebinarSessionVideo(
  locale: string,
  parentId: string,
  masterBlockId?: MasterBlockId,
): WebinarSessionVideoInterface {
  const videoPlaceholderUrl =
    locale === PageLocaleEnum.FRENCH
      ? 'https://youtu.be/4hoeL-l-b_4'
      : 'https://youtu.be/f48bbvvDJFQ'
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarSessionVideo,
      parentId,
      masterBlockId,
    ),
    autoplay: true,
    controls: false,
    url: videoPlaceholderUrl,
    border: {
      radius: 8,
    },
  }
}
